import * as React from "react";
import { Form, Input, Button, message, Select } from "antd";
import { users } from "@/api";
import { omit } from "@/util";
import styled from "styled-components";
import { useDepts } from "@/pages/main/Users/index";

const Container = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  flex-direction: column;
  position: absolute;
  top: 0;
  z-index: 1;
  background: #fff;
  width: 100%;
  height: 100%;
  .atitle {
    display: flex;
    width: 100%;
    align-items: center;
    font-size: 16px;
    font-weight: bold;
    cursor: pointer;
    margin-top: 30px;
    height: 80px;
    justify-content: center;
  }
`;

interface CreateProps {
  cancel: () => void;
}

const Create: React.FunctionComponent<CreateProps> = ({ cancel }) => {
  const [downNumber, setDownNumber] = React.useState(0);
  const [phoneNumber, setPhoneNumber] = React.useState("");

  const { depts } = useDepts()

  React.useEffect(() => {
    if (downNumber > 0) {
      setTimeout(() => {
        setDownNumber(downNumber - 1);
      }, 1000);
    }
  }, [downNumber]);

  const buttonTxt = React.useMemo(
    () => (downNumber === 0 ? "发送验证码" : `${downNumber} S`),
    [downNumber]
  );

  const handleSubmit = async (values: any) => {
    try {
      values.phoneNum = values.phone;
      values.checkCode = 123456;
      const params: users.RegProps = omit(
        values,
        "cfmPassword"
      ) as users.RegProps;
      await users.regist(params);
      message.success("新增用户成功");
      cancel();
    } catch (error: any) {
      const msg = error?.message || "新增用户失败，请稍后重试";
      message.error(msg);
    }
  };

  const sendCaptcha = async () => {
    if (!/1[\d]{10}/.test(phoneNumber)) {
      message.error("手机号码不正确");
      return;
    }
    await users.sendcode(phoneNumber);
    setDownNumber(59);
  };

  const phoneChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    const v = e.target.value;
    setPhoneNumber(v);
  };

  return (
    <Container>
      <Form onFinish={handleSubmit} initialValues={{ deptId: 100 }}>
        <div className="atitle">
          <h2>新增用户</h2>
        </div>
        <Form.Item
          name="username"
          rules={[
            { required: true, message: "账号不能为空" },
            { max: 20, message: "账号不得超过20位" }
          ]}
        >
          <Input placeholder="请输入账号" />
        </Form.Item>
        <Form.Item
          name="phone"
          rules={[
            { required: true, message: "手机号码不能为空" },
            {
              pattern: /^1[3-9]\d{9}$/, // 正则表达式验证中国大陆手机号码
              message: "请输入有效的手机号码",
            }
          ]}
        >
          <Input placeholder="请输入手机号码" onChange={phoneChangeHandler} />
        </Form.Item>
        <Form.Item
          name="password"
          rules={[
            { required: true, message: "密码不能为空" },
            { min: 6, message: "密码最少为6位数" },
          ]}
        >
          <Input type="password" placeholder="请输入密码" />
        </Form.Item>
        
        <Form.Item name="nickname">
          <Input placeholder="请输入昵称" />
        </Form.Item>

        <Form.Item name="deptId">
          <Select options={depts} />
        </Form.Item>

        <Form.Item>
          <div style={{ display: "flex", justifyContent: "space-between", gap: '1rem' }}>
            <Button type="primary" htmlType="submit" block>
              确定
            </Button>
            <Button type="primary" htmlType="reset" block onClick={cancel}>
              取消
            </Button>
          </div>
        </Form.Item>
      </Form>
    </Container>
  );
};

export default Create;
